import React from "react"
import AppSidebarGroup from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarGroup";
import AppSidebarMenuItem from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarMenuItem";
import {getChildRouterLink} from "root/Wieldy/routePaths";
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import {ChildDashboardFilters} from "root/DataFunctions/Constants";
import phpVars from 'phpVars';

const ChildDashboardSubmenu = (props ) =>
{
    const {search} = useLocation();
    const queryParams = queryString.parse(search);

    const child_dashboard_filter = queryParams.type === undefined ? ChildDashboardFilters.LOGINS : queryParams.type;
    const has_lifestory = phpVars.has_lifestory === 1 ? true :false;

    return (
        <AppSidebarGroup title='Dashboard' default={child_dashboard_filter}>
            <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'stats?type=logins')} title='Logins' iconName='icon-chart' name={ChildDashboardFilters.LOGINS} />
            {has_lifestory && <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'stats?type=posts-received')} title='Posts Received' iconName='icon-camera' name={ChildDashboardFilters.POSTS_RECIEVED}/>}
            {has_lifestory && <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'stats?type=posts-sent')} title='Posts Sent' iconName='icon-camera' name={ChildDashboardFilters.POSTS_SENT}/>}
            <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'stats?type=messages-received')} title='Messages Received' iconName='icon-chat' name={ChildDashboardFilters.MESSAGES_RECIEVED}/>
            <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'stats?type=messages-sent')} title='Messages Sent' iconName='icon-chat' name={ChildDashboardFilters.MESSAGES_SENT}/>
            {has_lifestory && <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'stats?type=diary')} title='Child Diary Entries' iconName='icon-calendar' name={ChildDashboardFilters.DIARY}/>}
        </AppSidebarGroup>
    )
}

export default ChildDashboardSubmenu ;